import React from 'react';
import { BadgeCheck } from 'lucide-react';
import { User } from '../../global-components/src/types';

interface ImgVerifiedProps {
  user?: User | null; // Propriedade opcional
  classNameProp?: string; // Propriedade opcional
}

const ImgVerified: React.FC<ImgVerifiedProps> = ({ user, classNameProp }) => {
  return (
      <span className='span-img-verified'>
        {/* {user?.id == 1 || user?.id == 2 ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src="/img/pacoca-sem-braco.png" loading="lazy"/>
          </>
        ) : null} */}
        {user?.stamps?.includes("black")  ? (
          <>
            <img className={`${classNameProp} img-vefified-company-color`} alt="Imagem de verificado" src="/img/selos/black.png" loading="lazy"/>
          </>
        ) : null}
        {user?.stamps?.includes("hidden_deficiencies")  ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src="/img/selos/hidden_deficiencies.png" loading="lazy"/>
          </>
        ) : null}
        {user?.stamps?.includes("brown")  ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src="/img/selos/brown.png" loading="lazy"/>
          </>
        ) : null}
        {user?.stamps?.includes("autism")  ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src="/img/selos/autism.png" loading="lazy"/>
          </>
        ) : null}
        {user?.stamps?.includes("lgbt")  ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src="/img/selos/lgbt.png" loading="lazy"/>
          </>
        ) : null}
        {user?.stamps?.includes("gray")  ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src="/img/selos/gray.png" loading="lazy"/>
          </>
        ) : null}
        {user?.stamps?.includes("yellow")  ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src="/img/selos/yellow.png" loading="lazy"/>
          </>
        ) : null}
        {user?.stamps?.includes("purple")  ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src="/img/selos/purple.png" loading="lazy"/>
          </>
        ) : null}
        {user?.stamps?.includes("blue")  ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src="/img/selos/verified.png" loading="lazy"/>
          </>
        ) : null}


        {user?.position === 1 ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src="/img/selos/brown.png" loading="lazy"/>
          </>
        ) : null}
        {user?.position === 2 ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src="/img/selos/darkBlue.png" loading="lazy"/>
          </>
        ) : null}

        {user?.position === 3 ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src="/img/selos/red.png" loading="lazy"/>
          </>
        ) : null}
       
        {user?.position === 4 ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src="/img/selos/peach.png" loading="lazy"/>
          </>
        ) : null}

        {/* {user?.position === 4 ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src="/img/selos/staff.png" loading="lazy"/>
          </>
        ) : null}

        {user?.position === 5 ? (
          <>
            <img className={`${classNameProp}`} alt="Imagem de verificado" src="/img/selos/help.png" loading="lazy"/>
          </>
        ) : null} */}
      </span>
  );
}

export default ImgVerified;
